'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('../../components');

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ErrorMessage component.
 * @param {ErrorMessagePropsType} props element
 * @returns {ReactElement} React element
 */
var ErrorMessageComponent = function (_React$Component) {
  (0, _inherits3.default)(ErrorMessageComponent, _React$Component);

  /**
   * Component constructor.
   *
   * @param {object} props element props
   * @public
   */
  function ErrorMessageComponent(props) {
    (0, _classCallCheck3.default)(this, ErrorMessageComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ErrorMessageComponent.__proto__ || (0, _getPrototypeOf2.default)(ErrorMessageComponent)).call(this, props));

    _this.handleOnRetry = function (event) {
      var _this$props = _this.props,
          restartDeposit = _this$props.restartDeposit,
          change = _this$props.change;

      event.preventDefault();
      setTimeout(function () {
        restartDeposit();
        change(_constants.QD_RF_FORM_NAME, _constants.QD_RF_FIELD_CVV, '');
      });
    };

    _this.onChatButtonClick = function () {
      window.open(_this.props.chatUrl, '_blank');
    };

    return _this;
  }

  /**
   * format the amount on blur event
   *
   * @param {Event} event the onblur event
   * @returns {void}
   */


  (0, _createClass3.default)(ErrorMessageComponent, [{
    key: 'render',


    /**
     * Render method for the component
     * @returns {Element<*>} the react element
     */
    value: function render() {
      var _props = this.props,
          showOtherMethods = _props.showOtherMethods,
          _props$t = _props.t,
          t = _props$t === undefined ? function () {
        var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return function (msg) {
          return '' + ctx + msg;
        };
      } : _props$t;

      var genericErrorTitle = t(_constants.TRANSLATION_CONTEXT)('APP_QD_ERR_GENERIC_FAIL_TITLE');
      var genericErrorMessage = _constants.QD_ERRORS_CODES.includes(this.props.errorMessage) ? t(_constants.TRANSLATION_CONTEXT)('APP_QD_ERR_GENERIC_FAIL_TEXT_' + this.props.errorMessage) : t(_constants.TRANSLATION_CONTEXT)('APP_QD_ERR_GENERIC_FAIL_TEXT');
      var retryButtonText = t(_constants.TRANSLATION_CONTEXT)('APP_QD_ERR_GENERIC_FAIL_RETRY_BUTTON');
      var dividerText = t(_constants.TRANSLATION_CONTEXT)('APP_QD_ERR_GENERIC_FAIL_DIVIDER');
      var footerHelpTitle = t(_constants.TRANSLATION_CONTEXT)('APP_QD_ERR_GENERIC_FAIL_HELP_TITLE');
      var footerChatButton = t(_constants.TRANSLATION_CONTEXT)('APP_QD_ERR_GENERIC_FAIL_HELP_CHAT');

      return _react2.default.createElement(_components.ErrorMessage, {
        dividerText: dividerText,
        footerChatButton: footerChatButton,
        footerHelpTitle: footerHelpTitle,
        genericErrorMessage: genericErrorMessage,
        genericErrorTitle: genericErrorTitle,
        onChatButtonClick: this.onChatButtonClick,
        onRetry: this.handleOnRetry,
        retryButtonText: retryButtonText,
        showOtherMethods: showOtherMethods
      });
    }
  }]);
  return ErrorMessageComponent;
}(_react2.default.Component);

exports.default = ErrorMessageComponent;